import { ScatterGraphComponent } from './scatter-graph.component';

export default angular
  .module('sfMobile.components.scatterGraph', ['sfMobile.services.chart'])
  .component('sfScatterGraph', ScatterGraphComponent).name;
